/**
 * Dev Mode Indicator Component
 * Shows a visual indicator when the app is running in development mode
 */

import { isDevMode } from "@/services/api";

const DevModeIndicator = () => {
  if (!isDevMode) return null;

  return (
    <div className="fixed top-4 right-4 z-50">
      <div className="bg-yellow-500 text-yellow-900 px-4 py-2 rounded-lg shadow-lg flex items-center gap-2 text-sm font-semibold">
        <span className="relative flex h-3 w-3">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-yellow-700 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-3 w-3 bg-yellow-700"></span>
        </span>
        🎭 DEV MODE
      </div>
    </div>
  );
};

export default DevModeIndicator;
